import { Box, Tabs, ToggleButton, styled } from '@mui/material'
import { ResponsiveContainer } from 'recharts'

export const HeroContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& h6': {
    color: theme.palette.grey[700]
  },
  '& svg': {
    color: theme.palette.grey[400]
  }
}))


export const StatCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#000',
  color: '#fff',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  minHeight: 120
}))

export const TapForm = styled(Tabs)(({ theme }) => ({
  '& .MuiTab-root': {
    border: '0px solid',
    borderBottom: `2px solid ${theme.palette.grey[200]}`,
    color: theme.palette.grey[400],
    height: '40px',
    minHeight: 'auto',
    marginTop: 8,
    fontWeight: 500
  },
  '& .Mui-selected': {
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    color: theme.palette.secondary.main,
    border: '0px solid'
  },
  '& .MuiTabs-indicator': {
    display: 'none'
  },
  '& .MuiTabs-root': {
    marginBottom: '16px'
  }
}))

export const InfoContent = styled(Box)(({ theme }) => ({
  '& p': {
    fontWeight: '500',
    color: theme.palette.grey[500],
    letterSpacing: '0.0015em',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 1,
    overflow: 'hidden',
    position: 'relative'
  },
  '& span': {
    lineHeight: '18px',
    letterSpacing: '0.0015em'
  }
}))

export const PeriodButton = styled(ToggleButton)(({ theme }) => ({
  border: '0px !important',
  textTransform: 'capitalize',
  color: `${theme.palette.grey[700]} !important`,
  '& p': {
    fontWeight: '500'
  },
  '&.Mui-selected': {
    borderRadius: '6px !important',
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: `${theme.palette.grey[50]} !important`,
    border: '0px !important'
  }
}))

export const SurfaceTooltip = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  backgroundColor: 'rgba(30, 30, 30, 0.75)',
  border: 'none',
  backdropFilter: 'blur(48px)',
  color: theme.palette.grey[50],
  borderRadius: 8
}))

export const StyledResponsiveContainer = styled(ResponsiveContainer)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily
}))
